<svg
  width="12"
  height="12"
  viewBox="0 0 13 13"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    width="12"
    height="12"
    fill="black"
    fill-opacity="0"
    transform="translate(0.563538 0.52037)"
  />
  <mask
    id="mask0"
    mask-type="alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="13"
    height="13"
  >
    <circle cx="6.56354" cy="6.52037" r="6" fill="#E5EEFC" />
  </mask>
  <g mask="url(#mask0)">
    <circle
      cx="6.56354"
      cy="6.52037"
      r="6"
      [attr.fill]="background || bgDefault"
    />
    <rect
      x="0"
      [attr.y]="getFillYPosition()"
      width="12"
      height="12"
      [attr.fill]="foreground || fgDefault"
      #fillerRect
    />
    <circle
      cx="6.56354"
      cy="6.52037"
      r="5.5"
      [attr.stroke]="foreground || fgDefault"
    />
  </g>
</svg>
